import React, { useState } from 'react';
import { Map as LeafletMap, Marker, Popup } from 'react-leaflet';
import { Translate} from '../../config/TranslationProvider';
import { Link } from 'react-router-dom';
import { MapboxTileLayer } from '../../api/mapbox';
import LocationMarker from './LocationMarker';
import * as Klaro from 'klaro';
import getKlaroConfig from '../../config/klaro';
import MapBoxConsentDialog from './MapBoxConsentDialog';

const MapSingle = ({location, title, resource = 'event', forEvent = false}) => {
    const latLng = [location.lat, location.lng];
    const address = location.address + ', ' + location.city + ', ' + location.country;

    const consentManager = Klaro.getManager(getKlaroConfig);
    const [mapBoxConsent, setMapBoxConsent] = useState(consentManager.getConsent('mapbox'));

    consentManager.watch({
        update: (obj, name) => {
            if (name === 'applyConsents') {
                setMapBoxConsent(obj.savedConsents.mapbox);
            }
        }
    });

    return (
        <div className="atbd_content_module">
            <div className="atbd_content_module__tittle_area">
                <div className="atbd_area_title">
                    <h4><span className="la la-map-o" />&nbsp;
                        <Translate value={title} />
                    </h4>
                </div>
            </div>

            {forEvent &&
                <div className="atbdb_content_module_contents" style={{paddingBottom: 0}}>
                    <div className="atbd_name_time">
                        <h4>{location.title}</h4>
                    </div>
                    <div className="atbd_widget_contact_info">
                        <ul>
                            <li>
                                <span className="la la-map-marker" />
                                <span className="atbd_info">{address}</span>
                            </li>
                        </ul>
                    </div>
                    <Link
                        to={'/locations/' + location.id}
                        className="btn btn-outline-secondary btn-block"
                        aria-label="location"
                    >
                        <Translate value="find_out_more" />
                    </Link>
                </div>
            }

            <div className="atbdb_content_module_contents">
                <LeafletMap
                    center={latLng}
                    zoom={13}
                    scrollWheelZoom={false}
                    style={{height: '400px'}}
                    gestureHandling={true}
                    gestureHandlingOptions={{
                        text: {
                            touch: 'Verschieben der Karte mit zwei Fingern',
                            scroll: 'Verwende STRG + Scrollen zum Zoomen der Karte',
                            scrollMac: 'Verwende \u2318 + Scrollen zum Zoomen der Karte',
                        },
                        duration: 1000,
                    }}
                >
                    {mapBoxConsent ?
                        <>
                            <MapboxTileLayer />

                            {resource === 'location' ?
                                <LocationMarker location={location} />
                                :
                                <Marker position={latLng}>
                                    <Popup>
                                        <div className="atbd_listing_data_list">
                                            <ul>
                                                <li>{address}</li>
                                            </ul>
                                        </div>

                                    </Popup>
                                </Marker>
                            }
                        </>
                        :
                        <MapBoxConsentDialog />
                    }
                </LeafletMap>
            </div>
        </div>
    );
};
export default MapSingle;
